import { FETCH_REDIRECT } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_REDIRECT:
      return { ...state, response: action.payload.data };
    default:
      return state;
  }
};
